import { RootState } from '@/store/state'

export default {
    updateStatisticsLocales(state: RootState, locales: Array<string>): void {
        state.statisticsState.locales = locales
    },
}
